import React from "react";
import {Box} from "@mui/material";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {ContractList} from "./ContractList/ContractList";


export const ContractsPage = () => {
    return (
        <TitleLayout title="Договоры">
            <Box pt={2} pb={2}>
                <ContractList/>
            </Box>
        </TitleLayout>
    )
}